// extracted by mini-css-extract-plugin
export default {"bet":"JkDag","betPrice":"WtBcn"};